import { LoadingButton } from "@mui/lab";
import {
  Box,
  InputLabel,
  Stack,
  TextField,
  Typography,
  Modal,
  IconButton,
  Tooltip,
  Select,
  MenuItem,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Chip,
  Button,
  Alert,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { forwardRef, useEffect, useMemo, useState } from "react";
import SnackAlert from "../../../components/SnackAlert";
import { useUser } from "../../../hooks/useUser";

// share react
import { FacebookShareButton, TwitterShareButton } from "react-share";
//icons
import {
  FaFacebook,
  FaTwitter,
  FaSpotify,
  FaInstagram,
  FaTiktok,
  FaGlobe,
} from "react-icons/fa";
import useSnack from "../../../hooks/useSnack";
import useApi from "../../../hooks/useApi";

import axios from "axios";
import spotifyToEmbed from "../../../utils/spotifyToEmbed";
import getRedesDifusor from "../../../utils/destinosDifusor";
import {
  redirectToSpotifyAuth,
  exchangeCodeForToken,
  getValidSpotifyToken,
  hasSpotifySession,
  clearSpotifySession,
} from "../../../utils/spotifyAuth";
import AddCircleOutlinedIcon from "@mui/icons-material/AddCircleOutlined";
import ContentPasteIcon from "@mui/icons-material/ContentPaste";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import {
  MAX_LINKS,
  linkDelPortapapeles,
  linkEsDeAlgunCanal,
  plataformaDeUrl,
} from "../../../utils/urlsPost";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {
  imagenParaCompartir,
  nombreDeArchivo,
  puedeCompartirArchivo,
} from "../../../utils/imagenParaCompartir";
import { usuarioDeRed } from "../../../utils/redesSociales";

// Dónde se publica a mano cuando el navegador no puede pasarle la imagen a la
// app (en la computadora): el sitio de la red, con su botón de "Crear".
const SITIO_RED = {
  instagram: "https://www.instagram.com/",
  facebook: "https://www.facebook.com/",
  tiktok: "https://www.tiktok.com/upload",
};

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

//style modal
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "100%",
  maxWidth: { xs: 300, sm: "400" },
  maxHeight: 500,
  overflow: "auto",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: "20px",
  "::-webkit-scrollbar": {
    display: "none",
  },
};

// B5: estilo del botón "Compartir en …" que envuelve cada share dialog
const REDES_NOMBRE = {
  instagram: "Instagram",
  facebook: "Facebook",
  tiktok: "TikTok",
  twitter: "X",
  spotify: "Spotify",
  web: "tu sitio",
};

// Ninguna red le devuelve a RadarFreim el link de lo que se publicó desde la
// hoja de compartir: el difusor lo copia en la app y lo pega acá. Esto le
// dice dónde está "Copiar enlace" en cada una.
const COMO_COPIAR_LINK = {
  instagram:
    "En Instagram, abre tu publicación, toca ··· y elige «Copiar enlace».",
  facebook:
    "En Facebook, abre tu publicación, toca «Compartir» y elige «Copiar enlace».",
  tiktok: "En TikTok, abre tu video, toca «Compartir» y elige «Copiar enlace».",
  twitter: "En X, abre tu post, toca el ícono de compartir y elige «Copiar enlace».",
  spotify:
    "En Spotify, abre la playlist, toca ··· → «Compartir» → «Copiar enlace».",
  web: "Copia la dirección de la nota ya publicada en tu sitio.",
};

const ICONO_PLATAFORMA = {
  instagram: [FaInstagram, "#E1306C"],
  facebook: [FaFacebook, "#3b5998"],
  tiktok: [FaTiktok, "#010101"],
  twitter: [FaTwitter, "#1DA1F2"],
  spotify: [FaSpotify, "#1DB954"],
};

const btnShare = (bg) => ({
  display: "inline-block",
  px: 2,
  py: 0.8,
  borderRadius: 1,
  cursor: "pointer",
  bgcolor: bg,
  color: "#fff",
  fontSize: "14px",
  textAlign: "center",
  "&:hover": { opacity: 0.9 },
});

export default function ModalView({ open, setOpen, loadingApi, loadDecision }) {
  const { user, updateUser } = useUser();
  const { loadApi } = useApi();
  // Un mensaje para canciones y otro para eventos ("escuchar esta canción"
  // no aplica a un show). Ambos se editan en Personalizar.
  const [mensajes, setMensajes] = useState({ cancion: "", evento: "" });
  const [plantillas, setPlantillas] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  // B5: destinos de publicación seleccionados (claves de red)
  const [seleccionadas, setSeleccionadas] = useState([]);
  //cerrar modal
  const handleOpenModal = () => {
    setOpenModal(false);
  };

  //Traer mensaje de compartir + respuestas rápidas de rechazo
  useEffect(() => {
    loadApi("general/parametros", false, "get").then((res) => {
      setMensajes({
        cancion: res.data.sharedMessage || "",
        evento: res.data.sharedMessageEvento || "",
      });
    });
  }, []);

  // Los motivos de rechazo dependen del tipo de envío: el endpoint devuelve
  // los de ese ámbito más los marcados como "ambos".
  useEffect(() => {
    if (!open?.status) return;
    loadApi(
      `general/respuestas_rapidas?tipo=${open.tipo || "cancion"}`,
      false,
      "get"
    )
      .then((res) => setPlantillas(res.data || []))
      .catch(() => setPlantillas([]));
  }, [open?.tipo, open?.status]);

  //Bloqueamos pegar en input feedback
  const handlePaste = (event) => {
    event.preventDefault();
    showSnack("No es posible pegar en este campo.", "warning");
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const { msgSB, openSB, showSnack, typeSB } = useSnack();
  const { status, url, preview } = open;
  const esEvento = open?.tipo === "evento";
  const shareMessage = esEvento ? mensajes.evento : mensajes.cancion;
  const nombreImagen = esEvento ? "flyer" : "portada";

  // La portada o el flyer como archivo, listo para compartir como imagen.
  // Se prepara apenas se abre el modal de aprobación (ver
  // utils/imagenParaCompartir: la hoja de compartir tiene que abrirse en el
  // mismo toque, sin esperar una descarga).
  const [imagen, setImagen] = useState({ estado: "sin-imagen", archivo: null });
  useEffect(() => {
    if (status !== "approve" || !preview?.cover) {
      setImagen({ estado: "sin-imagen", archivo: null });
      return undefined;
    }
    let vigente = true;
    setImagen({ estado: "cargando", archivo: null });
    imagenParaCompartir(
      preview.cover,
      nombreDeArchivo(preview?.cancion, nombreImagen)
    )
      .then((archivo) => vigente && setImagen({ estado: "lista", archivo }))
      .catch(() => vigente && setImagen({ estado: "error", archivo: null }));
    return () => {
      vigente = false;
    };
  }, [status, preview?.cover]);
  const compartirConImagen = puedeCompartirArchivo(imagen.archivo);
  //form
  const [form, setForm] = useState({
    status: "",
    feedback: "",
  });

  const handleClose = () => {
    setForm({ status: "", feedback: "" });
    setSeleccionadas([]);
    setLinks([""]);
    setActivacion(null);
    setOpen(false);
  };

  const handleSubmit = () => {
    const data = { ...form, status: status };
    if (data.status === "rejected" && data.feedback.length >= 100) {
      loadDecision(open.id, data);
      setForm({ status: "", feedback: "" });
    } else if (data.status === "approve") {
      if (linksLimpios.length === 0) {
        showSnack("Agrega el link de al menos una publicación.", "warning");
        return;
      }
      if (esDe5RC && activacion && !cumple5RC) {
        showSnack(
          canales5RC.length === 0
            ? "No tienes activados los envíos de 5 RC: rechaza el envío o solicítalo desde tu perfil."
            : "Al menos uno de los links tiene que ser de tu canal aprobado.",
          "warning"
        );
        return;
      }
      // B5: se registra en qué redes/destinos eligió publicar el difusor
      loadDecision(open.id, {
        ...data,
        urls_post: linksLimpios,
        redes_publicadas: seleccionadas,
      });
      updateUser();
      setForm({ status: "", feedback: "" });
      setSeleccionadas([]);
      setLinks([""]);
    } else {
      showSnack("El feedback debe tener mínimo 100 caracteres", "warning");
    }
  };

  // B5: destinos de publicación disponibles, derivados de las redes que el
  // difusor registró en su perfil (mismo criterio que el backend). Cada destino
  // trae su mecánica: "share" (share dialog web), "spotify" (agregar a
  // playlist), "web" (nota de prensa manual) o "disabled" (sin share web).
  const redesDifusor = useMemo(() => getRedesDifusor(user?.profile), [user]);
  const destinos = useMemo(() => {
    const lista = [];
    // En un evento lo que se publica es el flyer: compartir el link de los
    // boletos dejaba una publicación con la vista previa de la boletera, sin
    // el flyer. En una canción el link sí es lo que importa (su vista previa
    // trae la portada y lleva a escucharla).
    if (redesDifusor.facebook)
      lista.push({
        key: "facebook",
        label: "Facebook",
        Icon: FaFacebook,
        color: "#3b5998",
        tipo: esEvento ? "imagen" : "share",
      });
    if (redesDifusor.twitter)
      lista.push({
        key: "twitter",
        label: "X (Twitter)",
        Icon: FaTwitter,
        color: "#1DA1F2",
        tipo: "share",
      });
    if (spotifyToEmbed(url))
      lista.push({
        key: "spotify",
        label: "Spotify",
        Icon: FaSpotify,
        color: "#1DB954",
        tipo: "spotify",
      });
    if (redesDifusor.pagina_web)
      lista.push({
        key: "web",
        label: "Nota de prensa (tu sitio)",
        Icon: FaGlobe,
        color: "#F27224",
        tipo: "web",
      });
    // Instagram y TikTok no tienen "compartir" web: se les pasa la imagen
    // con la hoja de compartir del celular (Instagram ofrece ahí publicación
    // o historia) y el texto queda copiado para pegarlo. Sin API, sin costo.
    // YouTube no es un destino de publicación, se excluye.
    if (redesDifusor.instagram)
      lista.push({
        key: "instagram",
        label: "Instagram",
        Icon: FaInstagram,
        color: "#E1306C",
        tipo: "imagen",
      });
    if (redesDifusor.tiktok)
      lista.push({
        key: "tiktok",
        label: "TikTok",
        Icon: FaTiktok,
        color: "#010101",
        tipo: "imagen",
      });
    return lista;
  }, [redesDifusor, url, esEvento]);

  // Links de las publicaciones: uno por cada lugar donde publicó el difusor.
  const [links, setLinks] = useState([""]);
  const linksLimpios = links.map((l) => l.trim()).filter(Boolean);

  // Un envío de 5 RC (Editorial o de Mención) se aprueba con al menos un
  // link de un canal que el equipo le aprobó al difusor. El servidor es el
  // que lo exige; acá se avisa antes y se marcan los links que cumplen.
  const esDe5RC = Number(preview?.radarCoin) > 1;
  const [activacion, setActivacion] = useState(null);
  useEffect(() => {
    if (status !== "approve" || !esDe5RC) return;
    loadApi("productor/activacion-5rc", true, "get")
      .then((res) => setActivacion(res.data))
      .catch(() => setActivacion(null));
  }, [status, esDe5RC]);
  const canales5RC =
    activacion?.estado === "aprobada" ? activacion.canales || [] : [];
  const cumple5RC = linksLimpios.some((l) => linkEsDeAlgunCanal(l, canales5RC));

  const agregarLink = (url) => {
    if (linksLimpios.includes(url)) {
      showSnack("Ese link ya está en la lista.", "info");
      return false;
    }
    if (linksLimpios.length >= MAX_LINKS) {
      showSnack(`Puedes agregar hasta ${MAX_LINKS} links.`, "warning");
      return false;
    }
    setLinks((prev) => {
      const vacio = prev.findIndex((l) => !l.trim());
      if (vacio === -1) return [...prev, url];
      const copia = [...prev];
      copia[vacio] = url;
      return copia;
    });
    return true;
  };

  // Lee el link que el difusor copió en la red y lo suma a la lista.
  const pegarLink = async (red) => {
    let texto;
    try {
      texto = await navigator.clipboard.readText();
    } catch (e) {
      showSnack(
        "Tu navegador no deja leer lo copiado: mantén presionado un campo de link y elige «Pegar».",
        "warning"
      );
      return;
    }
    const url = linkDelPortapapeles(texto);
    const nombre = REDES_NOMBRE[red] || "la red";
    // Lo copiado sigue siendo el texto de la publicación, o el link de
    // boletos o de la canción: eso no es el link del post.
    if (!url || url === linkDelPortapapeles(open?.url)) {
      showSnack(
        red
          ? `Todavía no copiaste el link de tu publicación. ${COMO_COPIAR_LINK[red]}`
          : "Lo copiado no es un link. Copia el link de tu publicación y vuelve a tocar «Pegar link».",
        "warning"
      );
      return;
    }
    if (!agregarLink(url)) return;
    const plataforma = plataformaDeUrl(url);
    if (red && red !== "web" && plataforma && plataforma !== red)
      showSnack(
        `Agregado, pero ese link es de ${REDES_NOMBRE[plataforma] || plataforma}, no de ${nombre}.`,
        "info"
      );
    else showSnack("Link agregado");
  };

  const toggleDestino = (key) =>
    setSeleccionadas((prev) =>
      prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
    );

  // Copia el texto de la nota de prensa (para publicar en el sitio propio)
  const copiarNota = () => {
    const texto = [
      preview?.cancion,
      preview?.artista ? `Artista: ${preview.artista}` : null,
      shareMessage,
      url,
    ]
      .filter(Boolean)
      .join("\n");
    navigator.clipboard
      .writeText(texto)
      .then(() => showSnack("Texto de la nota copiado"))
      .catch(() => showSnack("No se pudo copiar", "error"));
  };

  // El @usuario del artista en esa red, si lo registró. En Instagram, TikTok
  // y X la mención escrita en el texto etiqueta de verdad al publicar; en
  // Facebook no (ahí hay que elegir la página a mano), así que no se pone.
  const mencion = (red) => {
    if (red === "facebook") return null;
    const usuario = usuarioDeRed(red, preview?.redes?.[red]);
    return usuario ? `@${usuario}` : null;
  };

  // El texto que acompaña la publicación en cada red: lo que se copia para
  // pegar y lo que se ve en la vista previa del modal.
  const textoPara = (red, { conLink = true } = {}) => {
    const arroba = mencion(red);
    const artista = preview?.artista
      ? `Artista: ${preview.artista}${arroba ? ` ${arroba}` : ""}`
      : arroba
        ? `Artista: ${arroba}`
        : null;
    const link = conLink && url ? (esEvento ? `Boletos: ${url}` : url) : null;
    return [
      preview?.cancion,
      artista,
      esEvento ? preview?.detalle : null,
      shareMessage,
      link,
    ]
      .filter(Boolean)
      .join("\n");
  };

  const copiarTexto = (red) => {
    navigator.clipboard
      .writeText(textoPara(red))
      .then(() => showSnack("Texto copiado, pégalo en tu publicación"))
      .catch(() => showSnack("No se pudo copiar", "error"));
  };

  // Abre la hoja de compartir del celular con la imagen. El texto se copia
  // en el mismo toque: Instagram y Facebook descartan el texto que llega
  // junto con una imagen, así que se pega como descripción.
  const compartirImagen = (red) => {
    if (!compartirConImagen) return;
    // Sin await: la hoja de compartir tiene que abrirse en este mismo toque.
    navigator.clipboard?.writeText(textoPara(red)).catch(() => {});
    navigator
      .share({ files: [imagen.archivo] })
      .catch(() => {
        /* la persona cerró la hoja de compartir: sin error */
      });
    showSnack(
      `Elige ${REDES_NOMBRE[red] || "la app"}. El texto quedó copiado: pégalo como descripción.`,
      "info"
    );
  };

  // Respaldo cuando no hay imagen que compartir (un evento sin flyer, o no se
  // pudo descargar): comparte texto y link con la hoja del sistema.
  const compartirTexto = async (red) => {
    const texto = textoPara(red);
    try {
      if (navigator.share) {
        await navigator.share({ title: preview?.cancion || "Radar Freim", text: texto });
        return;
      }
      copiarTexto(red);
    } catch {
      /* la persona cerró la hoja de compartir: sin error */
    }
  };

  // Descarga la imagen (ya en JPEG) para subirla a mano desde la computadora.
  const descargarImagen = () => {
    if (!imagen.archivo) {
      if (preview?.cover) window.open(preview.cover, "_blank", "noopener");
      return;
    }
    const objUrl = URL.createObjectURL(imagen.archivo);
    const a = document.createElement("a");
    a.href = objUrl;
    a.download = imagen.archivo.name;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(objUrl), 1000);
  };

  //spotify (Authorization Code + PKCE — el implicit grant ya no existe en Spotify)
  const [spotify, setSpotify] = useState(false);
  const [playlists, setPlaylists] = useState([]);
  const [loadingSpotify, setLoadingSpotify] = useState(false);

  useEffect(() => {
    // Retorno de la autorización de Spotify: llega ?code= en la URL
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    if (code) {
      // limpiar la URL para no reutilizar el code en un refresh
      window.history.replaceState(
        {},
        document.title,
        window.location.pathname
      );
      exchangeCodeForToken(code)
        .then(() => {
          setSpotify(true);
          showSnack("¡Sesión de Spotify iniciada!");
          // Retomar la aprobación que quedó a medias antes del redirect:
          // se reabre el modal con su canción y se muestran las playlists.
          const contexto = sessionStorage.getItem("spotify_pending_open");
          if (contexto) {
            sessionStorage.removeItem("spotify_pending_open");
            try {
              setOpen(JSON.parse(contexto));
            } catch {}
            handlePLaylists();
          }
        })
        .catch(() => {
          showSnack(
            "No se pudo conectar con Spotify, intenta de nuevo.",
            "error"
          );
          setSpotify(false);
        });
    } else if (hasSpotifySession()) {
      setSpotify(true);
    }
  }, []);

  //Mensaje según el error que devuelva Spotify
  const handleSpotifyError = (error) => {
    clearSpotifySession();
    setSpotify(false);
    if (error?.response?.status === 403) {
      // 403 con token válido: cuenta sin acceso a la app (modo desarrollo).
      // Se muestra la razón textual de Spotify para diagnosticar en pantalla.
      const razonSpotify = error?.response?.data?.error?.message;
      showSnack(
        `Spotify rechazó el acceso (403${
          razonSpotify ? `: "${razonSpotify}"` : ""
        }). Si la app está en modo desarrollo, esta cuenta debe estar autorizada en User Management del dashboard de Spotify.`,
        "error"
      );
    } else {
      showSnack("La sesión de spotify expiró, vuelva a iniciar.", "warning");
    }
  };

  //Ver las playlist
  const handlePLaylists = async () => {
    const token = await getValidSpotifyToken();
    if (!token) {
      showSnack("La sesión de spotify expiró, vuelva a iniciar.", "warning");
      setSpotify(false);
      return;
    }
    try {
      const { data } = await axios.get(
        "https://api.spotify.com/v1/me/playlists",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: { limit: 10 },
        }
      );
      setSpotify(true);
      setOpenModal(true);
      setPlaylists(data.items);
    } catch (error) {
      handleSpotifyError(error);
    }
  };

  //funcion para transformar una url de spotify a uri track
  //(acepta cualquier variante intl-*, igual que spotifyToEmbed)
  const urlToSpotifyUri = (url) => {
    const match = String(url || "").match(
      /https?:\/\/open\.spotify\.com\/(?:intl-[a-z]{2}(?:-[a-z]{2})?\/)?track\/([a-zA-Z0-9]+)/i
    );
    return match ? `spotify:track:${match[1]}` : null;
  };

  //endpoint de agregar cancion a playlist
  const handleAddToPlaylist = async (playlist_id) => {
    setLoadingSpotify(true);
    const uris = [urlToSpotifyUri(url)];
    const token = await getValidSpotifyToken();
    if (!token) {
      setLoadingSpotify(false);
      showSnack("Sesión expiró vuelva a inicar sesion de spotify", "error");
      setSpotify(false);
      return;
    }
    try {
      await axios.post(
        `https://api.spotify.com/v1/playlists/${playlist_id}/tracks`,
        { uris: uris },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      setLoadingSpotify(false);
      showSnack("¡Canción agregada!");
    } catch (error) {
      setLoadingSpotify(false);
      const status = error.response?.status;
      if (status === 401 || status === 403) {
        handleSpotifyError(error);
      } else
        showSnack(
          error.response?.data?.error?.message || "Error con Spotify",
          "error"
        );
    }
  };

  const handleSignInSpotify = () => {
    // Guardar la aprobación en curso para retomarla al volver de Spotify
    if (open) sessionStorage.setItem("spotify_pending_open", JSON.stringify(open));
    redirectToSpotifyAuth();
  };

  return (
    <>
      <Dialog
        open={Boolean(open)}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
      >
        <DialogTitle
          sx={{
            mb: 2,
            py: 1.5,
            borderBottom:
              open.status === "approve" ? "2px solid green" : "2px solid red",
          }}
        >
          <Stack direction="row" justifyContent="space-between">
            <Box>
              {`${open.status === "approve" ? "Aprobar" : "Rechazar"} ${
                esEvento ? "evento" : "canción"
              }`}
            </Box>
            <Box
              onClick={handleClose}
              sx={{
                cursor: "pointer",
                width: "30px",
                height: "30px",
                borderRadius: "50%",
                // boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.75)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              x
            </Box>
          </Stack>
        </DialogTitle>

        <DialogContent>
          <Stack spacing={2}>
            <Stack spacing={1}>
              <InputLabel>
                Feedback {status === "approve" && "(opcional)"}{" "}
              </InputLabel>
              {status === "rejected" && plantillas.length > 0 && (
                <Select
                  size="small"
                  displayEmpty
                  value=""
                  onChange={(e) => {
                    if (e.target.value)
                      setForm((prev) => ({ ...prev, feedback: e.target.value }));
                  }}
                  sx={{ maxWidth: { xs: "100%", sm: "500px" } }}
                  renderValue={() => "Usar una respuesta rápida…"}
                >
                  {plantillas.map((plantilla) => (
                    <MenuItem
                      key={plantilla.id}
                      value={plantilla.texto}
                      sx={{ maxWidth: "500px", whiteSpace: "normal" }}
                    >
                      {plantilla.texto}
                    </MenuItem>
                  ))}
                </Select>
              )}
              <TextField
                type="text"
                onPaste={handlePaste}
                value={form.feedback ?? ""}
                placeholder="Dale tu opinión al músico, pero se amable. (mínimo 100 caracteres)"
                sx={{ width: { xs: "100%", sm: "500px" } }}
                onChange={(e) => setForm({ ...form, feedback: e.target.value })}
                multiline
                rows={4}
                error={
                  status === "rejected" &&
                  form.feedback.length > 0 &&
                  form.feedback.length < 100
                }
                helperText={`${form.feedback.length}/1000 caracteres${
                  status === "rejected" ? " (mínimo 100)" : ""
                }`}
                inputProps={{ maxLength: 1000 }}
              />
            </Stack>
          </Stack>
          {status === "approve" && (
            <Stack mt={1.5} spacing={1}>
              <Typography variant="body1">Publica y comparte en:</Typography>
              {destinos.length === 0 ? (
                <Typography variant="caption" color="text.secondary">
                  No tienes redes ni página web registradas para publicar.
                  Agrégalas en tu perfil para habilitar la publicación.
                </Typography>
              ) : (
                <>
                  {/* Selector de destinos (chips) */}
                  <Stack direction="row" sx={{ flexWrap: "wrap", gap: 1 }}>
                    {destinos.map((d) =>
                      d.tipo === "disabled" ? (
                        <Tooltip
                          key={d.key}
                          title="Requiere integración por API (fase 2), aún no disponible"
                        >
                          <span>
                            <Chip
                              icon={<d.Icon />}
                              label={d.label}
                              size="small"
                              variant="outlined"
                              disabled
                            />
                          </span>
                        </Tooltip>
                      ) : (
                        <Chip
                          key={d.key}
                          icon={<d.Icon color={d.color} />}
                          label={d.label}
                          size="small"
                          variant={
                            seleccionadas.includes(d.key) ? "filled" : "outlined"
                          }
                          color={
                            seleccionadas.includes(d.key) ? "primary" : "default"
                          }
                          onClick={() => toggleDestino(d.key)}
                        />
                      )
                    )}
                  </Stack>

                  {/* Previsualización colapsable por destino seleccionado */}
                  {seleccionadas.map((key, idx) => {
                    const d = destinos.find((x) => x.key === key);
                    if (!d) return null;
                    return (
                      <Accordion
                        key={key}
                        defaultExpanded={idx === 0}
                        disableGutters
                        sx={{ boxShadow: "none", border: "1px solid #eee" }}
                      >
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                          <Stack
                            direction="row"
                            spacing={1}
                            alignItems="center"
                          >
                            <d.Icon color={d.color} />
                            <Typography variant="body2">{d.label}</Typography>
                          </Stack>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Stack spacing={1.5}>
                            {/* Tarjeta que simula el post */}
                            <Stack
                              direction="row"
                              spacing={1.5}
                              sx={{
                                p: 1,
                                borderRadius: 2,
                                bgcolor: "#fafafa",
                                border: "1px solid #eee",
                              }}
                            >
                              {preview?.cover && (
                                <img
                                  src={preview.cover}
                                  alt=""
                                  width="64"
                                  height="64"
                                  style={{ objectFit: "cover", borderRadius: 6 }}
                                />
                              )}
                              <Stack sx={{ minWidth: 0 }}>
                                <Typography variant="subtitle2" noWrap>
                                  {preview?.cancion ||
                                    (esEvento ? "Evento" : "Canción")}
                                </Typography>
                                {/* El texto tal cual se va a copiar, sin el
                                    título que ya está arriba. */}
                                <Typography
                                  variant="caption"
                                  sx={{
                                    mt: 0.5,
                                    whiteSpace: "pre-wrap",
                                    overflowWrap: "anywhere",
                                  }}
                                >
                                  {textoPara(key, {
                                    conLink: d.tipo !== "share",
                                  })
                                    .split("\n")
                                    .slice(preview?.cancion ? 1 : 0)
                                    .join("\n")}
                                </Typography>
                                {d.tipo === "share" && url && (
                                  <Typography
                                    variant="caption"
                                    color="primary"
                                    noWrap
                                  >
                                    {url}
                                  </Typography>
                                )}
                              </Stack>
                            </Stack>

                            {/* Acción según la mecánica del destino */}
                            {d.tipo === "share" && d.key === "facebook" && (
                              <FacebookShareButton url={url} quote={shareMessage}>
                                <Box sx={btnShare("#3b5998")}>
                                  Compartir en Facebook
                                </Box>
                              </FacebookShareButton>
                            )}
                            {d.tipo === "share" && d.key === "twitter" && (
                              <TwitterShareButton
                                url={url}
                                title={textoPara("twitter", { conLink: false })}
                              >
                                <Box sx={btnShare("#1DA1F2")}>
                                  Compartir en X
                                </Box>
                              </TwitterShareButton>
                            )}
                            {d.tipo === "spotify" && (
                              <Button
                                variant="outlined"
                                size="small"
                                onClick={
                                  spotify ? handlePLaylists : handleSignInSpotify
                                }
                                sx={{ alignSelf: "flex-start" }}
                              >
                                {spotify
                                  ? "Elegir playlist"
                                  : "Conectar Spotify"}
                              </Button>
                            )}
                            {d.tipo === "web" && (
                              <Stack spacing={0.5}>
                                <Typography
                                  variant="caption"
                                  color="text.secondary"
                                >
                                  Publica esta nota en tu sitio y pega la URL del
                                  artículo en el campo "URL del post" de arriba.
                                </Typography>
                                <Button
                                  variant="outlined"
                                  size="small"
                                  onClick={copiarNota}
                                  sx={{ alignSelf: "flex-start" }}
                                >
                                  Copiar texto de la nota
                                </Button>
                              </Stack>
                            )}
                            {d.tipo === "imagen" && (
                              <Stack spacing={1}>
                                {preview?.redes?.facebook &&
                                  key === "facebook" && (
                                    <Typography
                                      variant="caption"
                                      color="text.secondary"
                                    >
                                      Para etiquetar al artista en Facebook,
                                      escribe @ en la descripción y elige su
                                      página: Facebook no permite que otra
                                      app lo etiquete por ti.
                                    </Typography>
                                  )}
                                {mencion(key) && (
                                  <Typography
                                    variant="caption"
                                    color="text.secondary"
                                  >
                                    El texto ya menciona a {mencion(key)}: al
                                    publicarlo queda etiquetado. En una
                                    historia, agrégalo con el sticker de
                                    mención.
                                  </Typography>
                                )}
                                <Typography
                                  variant="caption"
                                  color="text.secondary"
                                >
                                  {imagen.estado === "cargando"
                                    ? `Preparando el ${nombreImagen}…`
                                    : compartirConImagen
                                      ? `Comparte el ${nombreImagen} y elige ${d.label}${
                                          key === "instagram"
                                            ? " (publicación o historia)"
                                            : ""
                                        }. El texto se copia solo: pégalo como descripción.`
                                      : imagen.archivo
                                        ? `Desde la computadora: descarga el ${nombreImagen}, copia el texto y súbelos en ${d.label}. Desde el celular lo puedes compartir directo a la app.`
                                        : `No hay ${nombreImagen} para compartir: se comparte el texto con el link.`}
                                </Typography>
                                <Stack
                                  direction="row"
                                  spacing={1}
                                  sx={{ flexWrap: "wrap", gap: 1 }}
                                >
                                  {compartirConImagen ? (
                                    <Button
                                      variant="contained"
                                      size="small"
                                      onClick={() => compartirImagen(key)}
                                      sx={{
                                        bgcolor: d.color,
                                        "&:hover": {
                                          bgcolor: d.color,
                                          opacity: 0.9,
                                        },
                                      }}
                                    >
                                      Compartir {nombreImagen} en {d.label}
                                    </Button>
                                  ) : imagen.archivo ? (
                                    <Button
                                      variant="contained"
                                      size="small"
                                      onClick={descargarImagen}
                                      sx={{
                                        bgcolor: d.color,
                                        "&:hover": {
                                          bgcolor: d.color,
                                          opacity: 0.9,
                                        },
                                      }}
                                    >
                                      Descargar {nombreImagen}
                                    </Button>
                                  ) : (
                                    imagen.estado !== "cargando" && (
                                      <Button
                                        variant="contained"
                                        size="small"
                                        onClick={() => compartirTexto(key)}
                                        sx={{
                                          bgcolor: d.color,
                                          "&:hover": {
                                            bgcolor: d.color,
                                            opacity: 0.9,
                                          },
                                        }}
                                      >
                                        Compartir…
                                      </Button>
                                    )
                                  )}
                                  <Button
                                    variant="outlined"
                                    size="small"
                                    onClick={() => copiarTexto(key)}
                                  >
                                    Copiar texto
                                  </Button>
                                  {compartirConImagen && (
                                    <Button
                                      variant="outlined"
                                      size="small"
                                      onClick={descargarImagen}
                                    >
                                      Descargar {nombreImagen}
                                    </Button>
                                  )}
                                  {!compartirConImagen && SITIO_RED[key] && (
                                    <Button
                                      variant="outlined"
                                      size="small"
                                      href={SITIO_RED[key]}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      Abrir {d.label}
                                    </Button>
                                  )}
                                </Stack>
                              </Stack>
                            )}
                            {/* Paso 2: traer el link de lo que publicó */}
                            <Stack
                              spacing={0.5}
                              sx={{ borderTop: "1px dashed #ddd", pt: 1 }}
                            >
                              <Typography
                                variant="caption"
                                color="text.secondary"
                              >
                                ¿Ya publicaste? {COMO_COPIAR_LINK[key]} Luego
                                vuelve aquí:
                              </Typography>
                              <Button
                                variant="outlined"
                                size="small"
                                startIcon={<ContentPasteIcon />}
                                onClick={() => pegarLink(key)}
                                sx={{ alignSelf: "flex-start" }}
                              >
                                Pegar link de {d.label}
                              </Button>
                            </Stack>
                          </Stack>
                        </AccordionDetails>
                      </Accordion>
                    );
                  })}
                </>
              )}

              {/* Los links de todas las publicaciones: el artista los ve
                  todos. Se pueden pegar desde cada red (arriba) o a mano. */}
              <Stack spacing={1} sx={{ pt: 1 }}>
                <InputLabel>Links de tus publicaciones</InputLabel>
                {esDe5RC && activacion && (
                  canales5RC.length > 0 ? (
                    <Alert severity={cumple5RC ? "success" : "info"}>
                      Este es un envío de 5 RC ({activacion.plan}): al menos
                      uno de los links tiene que ser de tu canal aprobado
                      {canales5RC.length > 1 ? "s" : ""} —{" "}
                      {canales5RC.map((c) => c.url).join(", ")}
                      {activacion.plan === "Editorial"
                        ? " — es decir, la nota publicada en tu sitio."
                        : "."}{" "}
                      Los links de otras redes suman, pero solos no alcanzan.
                    </Alert>
                  ) : (
                    <Alert severity="warning">
                      Este es un envío de 5 RC y no tienes activados los envíos
                      de 5 RC, así que no puedes aprobarlo. Recházalo para que
                      al artista se le devuelvan sus RC, o solicita la
                      activación desde tu perfil.
                    </Alert>
                  )
                )}
                <Typography variant="caption" color="text.secondary">
                  Agrega el link de cada publicación que hiciste (post,
                  historia, nota…). Tienen que ser de tus redes o tu sitio
                  registrados en el perfil.
                </Typography>
                {links.map((link, i) => {
                  const [IconoRed, color] = ICONO_PLATAFORMA[
                    plataformaDeUrl(link)
                  ] || [FaGlobe, "#9e9e9e"];
                  return (
                    <Stack
                      key={i}
                      direction="row"
                      spacing={1}
                      alignItems="center"
                    >
                      <IconoRed color={link.trim() ? color : "#bdbdbd"} />
                      {esDe5RC && linkEsDeAlgunCanal(link, canales5RC) && (
                        <Tooltip title="Es de tu canal aprobado">
                          <CheckCircleIcon color="success" fontSize="small" />
                        </Tooltip>
                      )}
                      <TextField
                        size="small"
                        fullWidth
                        placeholder="https://www.instagram.com/p/…"
                        value={link}
                        inputProps={{ "aria-label": `Link ${i + 1}` }}
                        onChange={(e) =>
                          setLinks((prev) =>
                            prev.map((l, j) => (j === i ? e.target.value : l))
                          )
                        }
                      />
                      {links.length > 1 && (
                        <IconButton
                          size="small"
                          aria-label={`Quitar link ${i + 1}`}
                          onClick={() =>
                            setLinks((prev) => prev.filter((_, j) => j !== i))
                          }
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      )}
                    </Stack>
                  );
                })}
                <Stack direction="row" sx={{ flexWrap: "wrap", gap: 1 }}>
                  <Button
                    size="small"
                    startIcon={<ContentPasteIcon />}
                    onClick={() => pegarLink(null)}
                  >
                    Pegar link
                  </Button>
                  <Button
                    size="small"
                    startIcon={<AddIcon />}
                    disabled={links.length >= MAX_LINKS}
                    onClick={() => setLinks((prev) => [...prev, ""])}
                  >
                    Agregar otro link
                  </Button>
                </Stack>
              </Stack>
            </Stack>
          )}
        </DialogContent>
        <DialogActions sx={{ pb: 2 }}>
          <LoadingButton
            loading={loadingApi.includes(`put__productor/envios/${open.id}`)}
            // onClick={() => loadDecision(open.id, form)}
            onClick={() => handleSubmit()}
            color={open.status === "approve" ? "success" : "error"}
          >
            Continuar
          </LoadingButton>
        </DialogActions>
      </Dialog>
      <SnackAlert openSB={openSB} typeSB={typeSB} msgSB={msgSB} />
      <Modal
        open={openModal}
        onClose={handleOpenModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography variant="h6">¡Elige tu playlist!</Typography>
          <Stack mt={4} spacing={2}>
            {playlists.map((item) => (
              <Stack
                key={item.id}
                direction="row"
                justifyContent="space-between"
              >
                <Stack direction="row" spacing={1}>
                  <Stack>
                    <img
                      src={item.images[0]?.url}
                      width="50px"
                      height="50px"
                      style={{ objectFit: "cover" }}
                    />
                  </Stack>
                  <Stack justifyContent="space-between" maxWidth="380px">
                    <Typography
                      variant="subtitle1"
                      sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "-webkit-box",
                        "-webkit-line-clamp": "2",
                        "-webkit-box-orient": "vertical",
                      }}
                    >
                      {item.name}
                    </Typography>
                    <Typography
                      variant="body1"
                      color="GrayText"
                      fontWeight={400}
                    >
                      Playlist colaboratíva: {item.colaborative ? "Si" : "No"}
                    </Typography>
                  </Stack>
                </Stack>
                <Stack justifyContent="center">
                  <LoadingButton
                    loading={loadingSpotify}
                    onClick={() => handleAddToPlaylist(item.id)}
                    sx={{ minWidth: "auto" }}
                    variant="text"
                  >
                    <AddCircleOutlinedIcon />
                  </LoadingButton>
                </Stack>
              </Stack>
            ))}
          </Stack>
        </Box>
      </Modal>
    </>
  );
}
